<nb-card>
  <nb-card-header>
    <div class="summary">
      <div class="item">
        <div class="avatar">
          <ngx-view-user-display
            [imageURL]="
              project.coverUrl
                ? project.coverUrl
                : '/assets/images/default_avatar.jpg'
            "
            [mode]="'avatar'"
            (onClick)="edit(project)"
          ></ngx-view-user-display>
        </div>

        <div>
          <a
            *ngIf="project?.title"
            class="text-body link"
            (onClick)="loadContent(true)"
          >
            <h6>{{ project.title }}</h6>
          </a>

          <div *ngIf="project.tags?.length > 0" class="text-link">
            <ngx-view-tags
              [tags]="project.tags"
              (onTagSelected)="tagSelected($event)"
            ></ngx-view-tags>
          </div>
        </div>
      </div>
    </div>

    <div class="button-action">
      <button
        nbButton
        ghost
        shape="round"
        status="primary"
        size="small"
        class="action-button"
        [disabled]="loading"
        [class.btn-pulse]="loading"
        [nbContextMenu]="menuItems"
        [nbContextMenuTag]="'action-buttons-' + project.id"
        (click)="loadButtonAction(project)"
      >
        <nb-icon icon="more-horizontal-outline"></nb-icon>
      </button>
    </div>
  </nb-card-header>

  <nb-card-body>
    <a *ngIf="!isMore" (click)="loadContent(true)" class="link text-link">
      <nb-icon icon="chevron-down-outline"></nb-icon>
      Mở rộng
    </a>

    <nb-card *ngIf="isMore">
      <nb-card-body>
        <ul class="detail">
          <li *ngIf="project.description">
            {{ "common.note" | translate }}:
            <span class="text-hint" style="white-space: pre">{{
              project.description
            }}</span>
          </li>
        </ul>
        <ngx-view-gallery
          *ngIf="project.imagesUrl?.length > 0"
          [imagesUrl]="project.imagesUrl"
        >
        </ngx-view-gallery>
      </nb-card-body>
    </nb-card>
    <div class="content">
      <a *ngIf="isMore" (click)="loadContent(false)" class="link text-link">
        <nb-icon icon="chevron-up-outline"></nb-icon>
      </a>

      <div *ngIf="isMore" class="button-action">
        <button
          nbButton
          ghost
          status="danger"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="delete(project)"
        >
          <nb-icon icon="trash-2-outline"></nb-icon>
        </button>

        <button
          nbButton
          ghost
          status="info"
          size="small"
          [disabled]="submitted"
          [class.btn-pulse]="submitted"
          (click)="edit(project)"
        >
          <nb-icon icon="edit-2-outline"></nb-icon>
        </button>
      </div>
    </div>
  </nb-card-body>
</nb-card>
